import { createAsyncThunk } from "@reduxjs/toolkit";
import { captureException } from "@sentry/react";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { ApiError } from "@/shared/types";
import { handleError } from "@/shared/lib/helpers/utils";

interface RetryPaymentProps {
  userId: number;
}

export const retryPayment = createAsyncThunk<void, RetryPaymentProps, ThunkConfig<ApiError>>(
  "subscription/retryPayment",
  async (params, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      await extra.api.post("/api/billing/retry_payment", params);
    } catch (err) {
      captureException(err);

      return rejectWithValue(handleError(err));
    }
  }
);
